import React, { useEffect, useState,useRef } from "react";
import { MDBInput } from "mdb-react-ui-kit";
// react plugin used to create datetimepicker
import ReactDatetime from "react-datetime";
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Row,
  CustomInput,
  Col,
} from "reactstrap";
import axios from "axios";
import apiService from "../../variables/apiService";
import {
  INSERT_WHATSAPP_CAMPAIGN,
  CHANNEL_CLIENT_CHNLTYPE,
  FETCH_GROUP_NAMES,
  ALL_META_TEMPLATES,
  BASE_URL_CHAT_WHATSAPP
} from "../../constants";
import SampleExcel from "./whatsappsamplefile.xlsx";
import NotificationAlert from "react-notification-alert";
import moment from "moment";
import LoadingScreen from "react-loading-screen";
import logo from "../../assets/img/logo.png";

let category = [
  {
    value: "",
    label: "Select Category",
    isDisabled: true,
  },
  { value: "Marketing", label: "Marketing" },
  { value: "Utility", label: "Utility" },
  { value: "Authentication", label: "Authentication" },
  { value: "Service", label: "Service" },
];

let categoryNum = [
  {
    value: "",
    label: "Select Category",
    isDisabled: true,
  },
  { value: 1, label: "Marketing" },
  { value: 2, label: "Utility" },
  { value: 3, label: "Authentication" },
  { value: 4, label: "Service" },
];

var initialValues = {
  file: "",
  name: "",
  message: "",
  date: moment().format("YYYY-MM-DD HH:mm A"),
  templateid: "",
  contactGroup: "",
  senderid: "",
  category: "",
  priority1: {
    templateid: "",
    channel: "",
    senderid: "",
  },
  priority2: {
    templateid: "",
    channel: "",
    senderid: "",
  },
  priority3: {
    templateid: "",
    channel: "",
    senderid: "",
  },
  priority4: {
    templateid: "",
    channel: "",
    senderid: "",
  },
};
let templates = [];
let senderids = [];
let groups = [];

let smstemplates = [];
let smssenderids = [];

let rcstemplates = [];
let rcssenderids = [];

let emailtemplates = [];
let emailsenderids = [];

let ivrtemplates = [];
let ivrsenderids = [];
var channels = [
  {
    value: "",
    label: "Select Channel",
    isDisabled: true,
  },
  { value: "SMS", label: "SMS" },
  { value: "Email", label: "Email" },
  { value: "RCS", label: "RCS" },
  { value: "IVR", label: "IVR" },
];

let userObj = localStorage.getItem("user");
let user = JSON.parse(userObj);
const Createcampaigns = () => {
  const [whatsappCampaign, setWhatsappCampaign] = useState(initialValues);

  const [validation, setValidation] = useState({ isvalid: false, message: "" });
  const notificationAlertRef = React.useRef(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [channel, setChannel] = useState([]);
  const [channelsms, setChannelsms] = useState([]);
  const [channelemail, setChannelemail] = useState([]);
  const [channelrcs, setChannelrcs] = useState([]);
  const [channelivr, setChannelivr] = useState([]);
  const [errorhandle, setErrorHandle] = useState();
  const [iscalbck, setiscalbck] = useState(false);
  const [ismanual, setIsManual] = useState(0);
  const [error, setError] = useState({
    error: "",
    iserror: false,
  });
  
  const [newlink, setNewlink] = useState(false);
  const fileRef = useRef(null);
  
  const [dummylink, setdummylink] = useState("");

  useEffect(() => {
    // fetchChanelsbyClient();
    fetchChanelsbyClientwtsap();
    fetchSmsChanelsbyClient();
    fetchEmailChanelsbyClient();
    fetchIvrChanelsbyClient();
    fetchRcsChanelsbyClient();
    viewGroupList();
  }, []);

  const viewGroupList = (pageNo) => {
    let lcObj = localStorage.getItem("user");
    let lclStrge = JSON.parse(lcObj);
    let clientid = lclStrge?.client;
    let user_id = lclStrge?.user_id;

    apiService
      .getData(`${FETCH_GROUP_NAMES}?user_id=${user_id}`)
      .then((response) => {
        groups = [];
        response?.data?.message?.map((group, i) => {
          group?.name &&
            groups.push({ value: group?.name, label: group?.name });
        });
     
      })
      .catch((error) => {
        console.log("????", error);
      }).finally(()=>{
   setIsLoading(false);
      })
  };

  const fetchChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      clientid: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(ALL_META_TEMPLATES, payload)
        .then((res) => {
          if (res?.data) {
            templates = [];

            //setWhatsappCampaign(res?.data)
            setChannel(res.data.message);

            res?.data?.message?.map((wtsap, i) => {
              wtsap?.name &&
                templates.push({ value: wtsap?.name, label: wtsap?.name });
            });
          }
          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }).finally(()=>{
          setIsLoading(false);
             }))
  };

  const fetchChanelsbyClientwtsap = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "whatsapp",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          if (res?.data) {
            templates = [];

            //setWhatsappCampaign(res?.data)
            setChannel(res?.data);

            res?.data?.map((wtsap, i) => {
              wtsap?.template &&
                templates.push({
                  value: wtsap?.template,
                  label: wtsap?.template,
                });
            });
          }
          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }).finally(()=>{
          setIsLoading(false);
             }));
  };

  //Fetching Template by RCS Channel

  const fetchRcsChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "rcs",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          rcstemplates = [];
          const chnlObj = res?.data[0];

          setChannelrcs(res?.data);
          //  setWhatsappCampaign({ ...whatsappCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              rcstemplates.push({
                value: item?.template,
                label: item?.template,
              });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }).finally(()=>{
          setIsLoading(false);
             }));
  };

  //Fetching Template by IVR Channel

  const fetchIvrChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "ivr",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          ivrtemplates = [];
          const chnlObj = res?.data[0];

          setChannelivr(res?.data);
          // setWhatsappCampaign({ ...whatsappCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              ivrtemplates.push({
                value: item?.template,
                label: item?.template,
              });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }).finally(()=>{
          setIsLoading(false);
             }));
  };

  //Fetching Template by SMS Channel

  const fetchSmsChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "sms",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          smstemplates = [];
          const chnlObj = res?.data[0];

          setChannelsms(res?.data);
          // setWhatsappCampaign({ ...whatsappCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              smstemplates.push({
                value: item?.template,
                label: item?.template,
              });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }).finally(()=>{
          setIsLoading(false);
             }));
  };

  //Fetching Template by Email Channel

  const fetchEmailChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "email",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          emailtemplates = [];
          const chnlObj = res?.data[0];

          setChannelemail(res?.data);
          //  setsmsCampaign({ ...smsCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              emailtemplates.push({
                value: item?.template,
                label: item?.template,
              });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }).finally(()=>{
          setIsLoading(false);
             }));
  };

  // const changeSender=(data)=>{
  //   senderids=[]

  //   const chnl=channel.filter(item=>item.name==data.value)
  // console.log(channel);
  //  // let catgry = category?.filter(item=>item.value===chnl[0]?.category)

  //   if(chnl[0]?.category){

  //    setWhatsappCampaign({...whatsappCampaign,category:{ value: chnl[0]?.category, label: chnl[0]?.category }})
  //   }else{
  //     setWhatsappCampaign({...whatsappCampaign,category:{ value: "", label: "Select" }})
  //   }

  //   const senderid = chnl[0]?.senderid?.split(",");
  //       for(let i=0;i<senderid?.length;i++){
  //         senderids.push({label:senderid[i],value:senderid[i]})
  //       }

  //   setWhatsappCampaign(prev=>({...prev,templateid:data,senderid:{label:user.sender_id,value:user.sender_id},message: chnl[0]?.components}))

  // }

  const changeSender = (data) => {
    setIsLoading(true);
    senderids = [];
    let catgry = [];
    const chnl = channel.filter(
      (item) => item?.template?.toLowerCase() == data?.value?.toLowerCase()
    );
    catgry = category?.filter(
      (item) => item.value?.toLowerCase() == chnl[0]?.category?.toLowerCase()
    );

    if (catgry.length == 0) {
      catgry = categoryNum?.filter((item) => item.value == chnl[0]?.category);
    }

    if (catgry[0]) {
      setWhatsappCampaign({ ...whatsappCampaign, category: catgry[0] });
    } else {
      setWhatsappCampaign({
        ...whatsappCampaign,
        category: { value: "", label: "Select" },
      });
    }

    const senderid = chnl[0]?.senderid?.split(",");
    for (let i = 0; i < senderid?.length; i++) {
      senderids.push({ label: senderid[i], value: senderid[i] });
    }

    setWhatsappCampaign((prev) => ({
      ...prev,
      templateid: data,
      senderid: "",
      message: chnl[0]?.content,
    }));
    setIsLoading(false);
  };

  const fetchSenderId = (data, chnl) => {
    if (chnl == "SMS") {
      smssenderids = [];
      const chnls = channelsms?.filter((item) => item.template == data.value);
      const senderid = chnls[0]?.senderid?.split(",");
      for (let i = 0; i < senderid?.length; i++) {
        smssenderids.push({ label: senderid[i], value: senderid[i] });
      }
    } else if (chnl == "Email") {
      emailsenderids = [];
      const chnls = channelemail?.filter((item) => item.template == data.value);
      const senderid = chnls[0]?.senderid?.split(",");
      for (let i = 0; i < senderid?.length; i++) {
        emailsenderids.push({ label: senderid[i], value: senderid[i] });
      }
    } else if (chnl == "RCS") {
      rcssenderids = [];
      const chnls = channelrcs?.filter((item) => item.template == data.value);
      const senderid = chnls[0]?.senderid?.split(",");
      for (let i = 0; i < senderid?.length; i++) {
        rcssenderids.push({ label: senderid[i], value: senderid[i] });
      }
    } else if (chnl == "IVR") {
      ivrsenderids = [];
      const chnls = channelivr?.filter((item) => item.template == data.value);
      const senderid = chnls[0]?.senderid?.split(",");
      for (let i = 0; i < senderid?.length; i++) {
        ivrsenderids.push({ label: senderid[i], value: senderid[i] });
      }
    }
  };

  const checkvalue = (value, priority) => {
    if (priority == "priority1") {
      if (whatsappCampaign?.priority2?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority2",
          value,
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority1: {
            ...preemailCampaign?.priority1,
            channel: "",
            templateid: "",
            senderid: "",
          },
        }));
      } else if (whatsappCampaign?.priority3?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority3",
          value,
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority1: {
            ...preemailCampaign?.priority1,
            channel: "",
            templateid: "",
            senderid: "",
          },
        }));
      } else if (whatsappCampaign?.priority4?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority4",
          value,
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority1: {
            ...preemailCampaign?.priority1,
            channel: "",
            templateid: "",
            senderid: "",
          },
        }));
      } else {
        setError({
          iserror: false,
          errorhandle: "",
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority1: {
            ...preemailCampaign?.priority1,
            channel: value,
            templateid: "",
            senderid: "",
          },
        }));
      }
    } else if (priority == "priority2") {
      if (whatsappCampaign?.priority1?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority1",
          value,
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority2: {
            ...preemailCampaign?.priority2,
            channel: "",
            templateid: "",
            senderid: "",
          },
        }));
      } else if (whatsappCampaign?.priority3?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority3",
          value,
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority2: {
            ...preemailCampaign?.priority2,
            channel: "",
            templateid: "",
            senderid: "",
          },
        }));
      } else if (whatsappCampaign?.priority4?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority4",
          value,
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority2: {
            ...preemailCampaign?.priority2,
            channel: "",
            templateid: "",
            senderid: "",
          },
        }));
      } else {
        setError({
          iserror: false,
          errorhandle: "",
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority2: {
            ...preemailCampaign?.priority2,
            channel: value,
            templateid: "",
            senderid: "",
          },
        }));
      }
    } else if (priority == "priority3") {
      if (whatsappCampaign?.priority1?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority1",
          value,
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority3: {
            ...preemailCampaign?.priority3,
            channel: "",
            templateid: "",
            senderid: "",
          },
        }));
      } else if (whatsappCampaign?.priority2?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority2",
          value,
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority3: {
            ...preemailCampaign?.priority3,
            channel: "",
            templateid: "",
            senderid: "",
          },
        }));
      } else if (whatsappCampaign?.priority4?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority4",
          value,
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority3: {
            ...preemailCampaign?.priority3,
            channel: "",
            templateid: "",
            senderid: "",
          },
        }));
      } else {
        setError({
          iserror: false,
          errorhandle: "",
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority3: {
            ...preemailCampaign?.priority3,
            channel: value,
            templateid: "",
            senderid: "",
          },
        }));
      }
    } else if (priority == "priority4") {
      if (whatsappCampaign?.priority1?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority1",
          value,
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority4: {
            ...preemailCampaign?.priority4,
            channel: "",
            templateid: "",
            senderid: "",
          },
        }));
      } else if (whatsappCampaign?.priority2?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority2",
          value,
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority4: {
            ...preemailCampaign?.priority3,
            channel: "",
            templateid: "",
            senderid: "",
          },
        }));
      } else if (whatsappCampaign?.priority3?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority3",
          value,
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority4: {
            ...preemailCampaign?.priority4,
            channel: "",
            templateid: "",
            senderid: "",
          },
        }));
      } else {
        setError({
          iserror: false,
          errorhandle: "",
        });
        setWhatsappCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority4: {
            ...preemailCampaign?.priority4,
            channel: value,
            templateid: "",
            senderid: "",
          },
        }));
      }
    }
  };

  const submitWhatsapp = () => {
    const isValid = validate();

    setErrorHandle(isValid);
    if (Object.keys(isValid).length == 0) {
      setIsLoading(true);
      let slctddate = "";
      if (
        moment(whatsappCampaign.date).format("YYYY-MM-DD HH:mm") !=
        "Invalid date"
      ) {
        slctddate = moment(whatsappCampaign.date).format("YYYY-MM-DD HH:mm");
      } else {
        slctddate = whatsappCampaign.date.slice(0, -2);
      }
      const formData = new FormData();
      if (whatsappCampaign?.file) {
        formData.append("file", whatsappCampaign.file);
      }

      formData.append("name", whatsappCampaign.name);
      formData.append("date", slctddate);
      formData.append("category", whatsappCampaign?.category?.value);

      formData.append("user_id", user.user_id);
      formData.append("senderid", whatsappCampaign.senderid?.value);
      formData.append("message", whatsappCampaign?.message);
      formData.append("template", whatsappCampaign.templateid?.value);
      formData.append("priority1", whatsappCampaign?.priority1?.channel);
      formData.append(
        "templateid1",
        whatsappCampaign?.priority1?.templateid?.value
      );
      formData.append(
        "senderid1",
        whatsappCampaign?.priority1?.senderid?.value
      );
      formData.append("priority2", whatsappCampaign?.priority2?.channel);
      formData.append(
        "templateid2",
        whatsappCampaign?.priority2?.templateid?.value
      );
      formData.append(
        "senderid2",
        whatsappCampaign?.priority2?.senderid?.value
      );

      formData.append("priority3", whatsappCampaign?.priority3?.channel);
      formData.append(
        "templateid3",
        whatsappCampaign?.priority3?.templateid?.value
      );
      formData.append(
        "senderid3",
        whatsappCampaign?.priority3?.senderid?.value
      );

      formData.append("priority4", whatsappCampaign.priority4?.channel?.value);
      formData.append(
        "templateid4",
        whatsappCampaign.priority4?.templateid?.value
      );
      formData.append(
        "senderid4",
        whatsappCampaign?.priority4?.senderid?.value
      );
      formData.append("contactgroup", whatsappCampaign?.contactGroup?.value);

      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      apiService
        .postData(INSERT_WHATSAPP_CAMPAIGN, formData, config)
        .then((response) => {
          setIsLoading(false);
          let options = {};
          options = {
            place: "tr",
            message: "Submitted Successfully",
            type: "success",

            autoDismiss: 2,
          };
          notificationAlertRef.current.notificationAlert(options);

          setWhatsappCampaign(initialValues);
          setdummylink("")
          setNewlink(false)
        })
        .catch((err) =>{
          console.log(err);
          let options = {};
          options = {
            place: "tr",
            message: err?.response?.data?.message,
            type: "warning",

            autoDismiss: 2,
          };
          notificationAlertRef.current.notificationAlert(options);
        } ).finally(()=>{
          setIsLoading(false);
          fileRef.current.value = "";
             });
    }
  };

  const validate = () => {
    const onlylettersRegex = /^[a-zA-Z ]+$/;
    let errors = {};
    if (!whatsappCampaign?.name) {
      errors.name = "Please Enter Name";
    } else if (whatsappCampaign?.name?.length <= 3) {
      errors.name = "Please Enter Valid Name";
    } else if (!whatsappCampaign?.name.match(onlylettersRegex)) {
      errors.name = "Please Enter Valid Name";
    }

    if (!whatsappCampaign?.templateid?.value) {
      errors.templateid = "Please Select Template";
    }
    if (!whatsappCampaign?.senderid?.value) {
      errors.senderid = "Please Select Sender Id";
    }
    // if(!whatsappCampaign.file){
    //   errors.file="Please Upload File "
    // }
    return errors;
  };

  const chooseFile = (e) => {
    let a = e.target.value.split(".");

    if (a[1] == "xlsx") {
      setValidation({
        isvalid: false,
        message: " ",
      });
      setWhatsappCampaign({ ...whatsappCampaign, file: e.target.files[0] });
    } else {
      setValidation({
        isvalid: true,
        message: "Not Supported " + a[1] + " format",
      });
    }
  };

 

  const uploadImglocal = (file) => {
    setdummylink("")
    const type= file.type?.split("/")[0];
    if(type == "video"&&file?.size>16000000){

      setValidation({
        isvalid: true,
        message: "Uploaded file size must not exceed 16 MB.",
      });
      
    }else if(type == "image"&&file?.size>5000000){
     
      setValidation({
        isvalid: true,
        message: "Uploaded file size must not exceed 5 MB.",
      }); 

    }else if(type== "document"&&file?.size>100000000){
      
      setValidation({
        isvalid: true,
        message: "Uploaded file size must not exceed 100 MB.",
      }); 
    }else{
      setValidation({
        isvalid: false,
        message: "",
      });
    setIsLoading(true)
    const formData = new FormData();
    formData.append("file", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(BASE_URL_CHAT_WHATSAPP + "/upload", formData, config)
      .then((response) => {
        setdummylink(response?.data?.Response);
      })
      .catch((err) => console.log("err==>", err)).finally(()=>{
        setIsLoading(false)
      })
    }
   
  };


  return (
    <>
      <div className="content">
        <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
        <NotificationAlert ref={notificationAlertRef} />
        <Row>
          <Col md="12" className="pt-2">
            <Card>
              <CardBody>
                <Form action="#">
                  <Row>
                    <Col md="3" sm="12">
                      <label>Name *</label>
                      <FormGroup>
                        <Input
                          type="Text"
                          placeholder="Enter Name"
                          value={whatsappCampaign.name}
                          onChange={(e) =>
                            setWhatsappCampaign({
                              ...whatsappCampaign,
                              name: e.target.value,
                            })
                          }
                        />
                      </FormGroup>
                      {errorhandle?.name && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.name}
                        </span>
                      )}
                    </Col>
                    <Col md="3" sm="12">
                      <p className="category">Select Date & Time *</p>
                      <FormGroup>
                        <ReactDatetime
                          inputProps={{
                            className: "form-control",
                            placeholder: "Date & Time",
                          }}
                          closeOnSelect={true}
                          timeFormat={true}
                          value={whatsappCampaign.date}
                          onChange={(val) =>
                            setWhatsappCampaign({
                              ...whatsappCampaign,
                              date: val._d,
                            })
                          }
                        />
                      </FormGroup>
                    </Col>

                    <Col md="3" sm="12">
                      <p className="category">
                        Select Template<suf style={{ color: "red" }}>*</suf>{" "}
                      </p>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="templateSelect"
                        value={whatsappCampaign.templateid}
                        onChange={(value) => changeSender(value)}
                        options={templates}
                        placeholder="Select"
                      />
                      {errorhandle?.templateid && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.templateid}
                        </span>
                      )}
                    </Col>

                    <Col md="3" sm="12">
                      <label>Category</label>
                      <FormGroup>
                        <Input
                          type="Text"
                          readOnly={true}
                          value={whatsappCampaign?.category?.label}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="3" sm="12">
                      <p className="category">Select Sender</p>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderSelect"
                        value={whatsappCampaign?.senderid}
                        onChange={(value) =>
                          setWhatsappCampaign((prev) => ({
                            ...prev,
                            senderid: value,
                          }))
                        }
                        options={senderids}
                        placeholder="Select"
                      />
                      {errorhandle?.senderid && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.senderid}
                        </span>
                      )}
                    </Col>
                    <Col md="3" sm="12">
                      <Label>Message Text</Label>
                      <Input
                        style={{
                          padding: "5px",
                          resize: "auto",
                          maxHeight: "none",
                        }}
                        type="textarea"
                        name="message"
                        value={whatsappCampaign?.message}
                        placeholder="Message Text"
                        onChange={(e) => {
                          setWhatsappCampaign({
                            ...whatsappCampaign,
                            message: e.target.value,
                          });
                        }}
                      />
                      {/* {errorhandle?.message && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.message}
                        </span>
                      )} */}
                    </Col>
                    <Col sm="3" className="mb-2 mt-5">
                      <div className="d-flex align-items-center">
                        <span className="mr-2">Group </span>
                        <CustomInput
                          type="switch"
                          id="switch-5"
                          className="mt-n4"
                          checked={ismanual === 0 ? true : false}
                          onChange={(e) => {
                            e.target.checked == true
                              ? setWhatsappCampaign({
                                  ...whatsappCampaign,
                                  contactGroup: "",
                                })
                              : setWhatsappCampaign({
                                  ...whatsappCampaign,
                                  file: "",
                                });
                            setIsManual(e.target.checked == true ? 0 : 1);
                          }}
                        />
                        <span className="ml-n2">File</span>
                      </div>
                    </Col>

                    {error.iserror && (
                      <h6 style={{ color: "red" }}>{error.errorhandle}</h6>
                    )}

                    {ismanual == 0 ? (
                      <Col md="3" sm="12" className="">
                        <Label>
                          Bulk Upload (
                          <b style={{ fontSize: "11px" }}>Upload Excel File</b>)
                        </Label>

                        <FormGroup>
                          <input
                            accept=".xlsx"
                            id="file"
                            ref={fileRef}
                            onChange={(e) => chooseFile(e)}
                            type="file"
                            style={{
                              opacity: "1",
                              position: "initial",
                              border: "solid 1px #eee",
                            }}
                          />
                          <a href={SampleExcel} download="whatsapp Sample File">
                            {" "}
                            <p style={{ color: "#e14eca" }}>
                              *Download sample Excel file
                            </p>
                          </a>
                        </FormGroup>

                        <span style={{ color: "red" }}>
                          {errorhandle?.file}
                        </span>
                      </Col>
                    ) : (
                      <Col md="3" sm="12">
                        <p className="category">Contact Groups</p>
                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="groupSelect"
                          value={whatsappCampaign.contactGroup}
                          onChange={(value) =>
                            setWhatsappCampaign({
                              ...whatsappCampaign,
                              contactGroup: value,
                            })
                          }
                          options={groups}
                          placeholder="Select"
                        />
                        {errorhandle?.templateid && (
                          <span style={{ color: "red" }}>
                            {errorhandle?.templateid}
                          </span>
                        )}
                      </Col>
                    )}
                    
                    <span style={{cursor:"pointer"}} onClick={()=>setNewlink(!newlink)}>Click here to generate new url</span>
                  {/* image upload functionality start */}
                 {
                  newlink&&<>
                  <hr></hr>
                  {
                    validation?.isvalid&&<span style={{color:"red"}}>{validation?.message}</span>
                  }
                   <Col
                                      md="12"
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "flex-start",
                                      }}
                                    >
                                      <input
                                        type="file"
                                        id="file"
                                       // ref={fileRef}
                                        accept="image/png,image/jpeg,video/mp4,application/pdf"
                                        onChange={(e) => {
                                          // setImg(e.target.files[0]);
                                          uploadImglocal(e.target.files[0]);
                                        }}
                                        style={{
                                          border: "1px sold grey",
                                          marginTop: "4px",
                                        }}
                                      />
                                    
                                    </Col>

                                    <div>
                                      <p style={{padding:"10px",margin:"10px"}}>{dummylink}</p>
                         {
                         (dummylink.toLowerCase().endsWith(".png")||dummylink.toLowerCase().endsWith(".jpeg"))&& <img
                          src={dummylink}
                          style={{
                            height: "auto",
                            width: "200px",
                            backgroundColor: "white",
                          }}
                        />
                         }
                         
                         {
                         dummylink.toLowerCase().endsWith(".mp4")&&
                            <video
                            width="280"
                            controls
                            crossOrigin="anonymous"
                            onPlay={() => console.log("Video started")}
                            onPause={() => console.log("Video paused")}
                          >
                            <source src={dummylink} type="video/mp4" />
                          </video>
                          }
                        </div>
                  </>
                 }
                
                  {/* image upload functionality end */}
                    <Col md="3" className="mb-2 mt-5">
                      <FormGroup check className="mt-0">
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={iscalbck}
                            value={iscalbck}
                            onClick={(e) => {
                              e.target.checked === true
                                ? setiscalbck(true)
                                : setiscalbck(false);
                            }}
                          />
                          <span className="form-check-sign" />
                          Fall back
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                  {iscalbck && (
                    <>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="2" className="mb-2 ">
                          <Label>Priority 1</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            // value={.smsSlct}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority1");
                              //setWhatsappCampaign({...whatsappCampaign,priority1.channel: value});
                              //  setWhatsappCampaign((preemailCampaign)=>({...preemailCampaign,priority1:{...preemailCampaign.priority1,channel:value}}))
                            }}
                            options={channels}
                            placeholder="Select Channel"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                            value={whatsappCampaign?.priority1?.templateid}
                            onChange={(value) => {
                              setWhatsappCampaign((preemailCampaign) => ({
                                ...preemailCampaign,
                                priority1: {
                                  ...preemailCampaign.priority1,
                                  templateid: value,
                                },
                              }));

                              fetchSenderId(
                                value,
                                whatsappCampaign.priority1.channel
                              );
                            }}
                            options={
                              whatsappCampaign?.priority1?.channel == "Email"
                                ? emailtemplates
                                : whatsappCampaign?.priority1?.channel == "IVR"
                                ? ivrtemplates
                                : whatsappCampaign?.priority1?.channel == "SMS"
                                ? smstemplates
                                : rcstemplates
                            }
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="senderId"
                            value={whatsappCampaign?.priority1?.senderid}
                            onChange={(value) => {
                              setWhatsappCampaign((preemailCampaign) => ({
                                ...preemailCampaign,
                                priority1: {
                                  ...preemailCampaign.priority1,
                                  senderid: value,
                                },
                              }));
                            }}
                            options={
                              whatsappCampaign?.priority1?.channel == "Email"
                                ? emailsenderids
                                : whatsappCampaign?.priority1?.channel == "IVR"
                                ? ivrsenderids
                                : whatsappCampaign?.priority1?.channel == "SMS"
                                ? smssenderids
                                : rcssenderids
                            }
                            placeholder="Select SenderId"
                          />
                        </Col>
                      </Row>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="2" className="mb-2 ">
                          <Label>Priority 2</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            options={channels}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority2");

                              //setWhatsappCampaign({...whatsappCampaign,priority1.channel: value});
                              //  setWhatsappCampaign((preemailCampaign)=>({...preemailCampaign,priority2:{...preemailCampaign.priority2,channel:value}}))
                            }}
                            placeholder="Select Channel"
                          />
                        </Col>

                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                            value={whatsappCampaign?.priority2?.templateid}
                            onChange={(value) => {
                              setWhatsappCampaign((preemailCampaign) => ({
                                ...preemailCampaign,
                                priority2: {
                                  ...preemailCampaign.priority2,
                                  templateid: value,
                                },
                              }));

                              fetchSenderId(
                                value,
                                whatsappCampaign.priority2.channel
                              );
                            }}
                            // options={selectType}
                            options={
                              whatsappCampaign?.priority2?.channel == "Email"
                                ? emailtemplates
                                : whatsappCampaign?.priority2?.channel == "IVR"
                                ? ivrtemplates
                                : whatsappCampaign?.priority2?.channel == "SMS"
                                ? smstemplates
                                : rcstemplates
                            }
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="senderId"
                            value={whatsappCampaign?.priority2?.senderid}
                            onChange={(value) => {
                              setWhatsappCampaign((preemailCampaign) => ({
                                ...preemailCampaign,
                                priority2: {
                                  ...preemailCampaign.priority2,
                                  senderid: value,
                                },
                              }));
                            }}
                            options={
                              whatsappCampaign?.priority2?.channel == "Email"
                                ? emailsenderids
                                : whatsappCampaign?.priority2?.channel == "IVR"
                                ? ivrsenderids
                                : whatsappCampaign?.priority2?.channel == "SMS"
                                ? smssenderids
                                : rcssenderids
                            }
                            placeholder="Select SenderId"
                          />
                        </Col>
                      </Row>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="2" className="mb-2 ">
                          <Label>Priority 3</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            options={channels}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority3");
                              //setWhatsappCampaign({...whatsappCampaign,priority1.channel: value});
                              //  setWhatsappCampaign((preemailCampaign)=>({...preemailCampaign,priority3:{...preemailCampaign.priority3,channel:value}}))
                            }}
                            placeholder="Select Channel"
                          />
                        </Col>

                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                            value={whatsappCampaign?.priority3?.templateid}
                            onChange={(value) => {
                              setWhatsappCampaign((preemailCampaign) => ({
                                ...preemailCampaign,
                                priority3: {
                                  ...preemailCampaign.priority3,
                                  templateid: value,
                                },
                              }));

                              fetchSenderId(
                                value,
                                whatsappCampaign.priority3.channel
                              );
                            }}
                            options={
                              whatsappCampaign?.priority3?.channel == "Email"
                                ? emailtemplates
                                : whatsappCampaign?.priority3?.channel == "IVR"
                                ? ivrtemplates
                                : whatsappCampaign?.priority3?.channel == "SMS"
                                ? smstemplates
                                : rcstemplates
                            }
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="senderId"
                            value={whatsappCampaign?.priority3?.senderid}
                            onChange={(value) => {
                              setWhatsappCampaign((preemailCampaign) => ({
                                ...preemailCampaign,
                                priority3: {
                                  ...preemailCampaign.priority3,
                                  senderid: value,
                                },
                              }));
                            }}
                            options={
                              whatsappCampaign?.priority3?.channel == "Email"
                                ? emailsenderids
                                : whatsappCampaign?.priority3?.channel == "IVR"
                                ? ivrsenderids
                                : whatsappCampaign?.priority3?.channel == "SMS"
                                ? smssenderids
                                : rcssenderids
                            }
                            placeholder="Select SenderId"
                          />
                        </Col>
                      </Row>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="2" className="mb-2 ">
                          <Label>Priority 4</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            options={channels}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority4");
                              //setWhatsappCampaign({...whatsappCampaign,priority1.channel: value});
                              //  setWhatsappCampaign((preemailCampaign)=>({...preemailCampaign,priority4:{...preemailCampaign.priority4,channel:value}}))
                            }}
                            placeholder="Select Channel"
                          />
                        </Col>

                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                            value={whatsappCampaign?.priority4?.templateid}
                            onChange={(value) => {
                              setWhatsappCampaign((preemailCampaign) => ({
                                ...preemailCampaign,
                                priority4: {
                                  ...preemailCampaign?.priority4,
                                  templateid: value,
                                },
                              }));

                              fetchSenderId(
                                value,
                                whatsappCampaign.priority4.channel
                              );
                            }}
                            options={
                              whatsappCampaign?.priority4?.channel == "Email"
                                ? emailtemplates
                                : whatsappCampaign?.priority4?.channel == "IVR"
                                ? ivrtemplates
                                : whatsappCampaign?.priority4?.channel == "SMS"
                                ? smstemplates
                                : rcstemplates
                            }
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="senderId"
                            value={whatsappCampaign?.priority4?.senderid}
                            onChange={(value) => {
                              setWhatsappCampaign((preemailCampaign) => ({
                                ...preemailCampaign,
                                priority4: {
                                  ...preemailCampaign.priority4,
                                  senderid: value,
                                },
                              }));
                            }}
                            options={
                              whatsappCampaign?.priority4?.channel == "Email"
                                ? emailsenderids
                                : whatsappCampaign?.priority4?.channel == "IVR"
                                ? ivrsenderids
                                : whatsappCampaign?.priority4?.channel == "SMS"
                                ? smssenderids
                                : rcssenderids
                            }
                            placeholder="Select SenderId"
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                  <Row>
                    <Col md="1" sm="12">
                      <Button
                        color="primary"
                        className="mt-4 btn btn-icon animation-on-hover"
                        id="tooltipsubmit"
                        type="button"
                        disabled={isLoading}
                        onClick={() => submitWhatsapp()}
                      >
                        <i className="tim-icons icon-double-right" />
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
          <Col md="3"></Col>
        </Row>
      </div>
    </>
  );
};

export default Createcampaigns;
